import { useEffectButNotOnMount } from '@hooks/useEffectButNotOnMount';
import { RootState } from '@state/ducks';
import { SET_SELECTED_VARIANT } from '@state/ducks/productdetail/productdetail.reducer';
import { useDispatch, useSelector } from 'react-redux';

const VARIANT_PARAMETER_NAME = 'variant' as const;

export const useUpdateUrlWithVariant = (): void => {
  const variantAgilityId = useSelector<RootState, number | null>(
    (state) => state.productDetail.selectedVariantAgilityId,
  );
  const dispatch = useDispatch();

  useEffectButNotOnMount(() => {
    // update window with new agilityID - this should only be being triggered when it changes due to useEffect anyway.
    const url = new URL(window.location.href);

    if (variantAgilityId === null) {
      url.searchParams.delete(VARIANT_PARAMETER_NAME);
    } else {
      url.searchParams.set(VARIANT_PARAMETER_NAME, variantAgilityId.toString());
    }

    window.history.pushState({}, '', url.toString());

    // change ID in redux store if url variant changes - this would happen with forward/back buttons on browser
    window.onpopstate = () => {
      const newVariantAgilityIdStringOrNull = new URL(window.location.href).searchParams.get(VARIANT_PARAMETER_NAME);
      if (newVariantAgilityIdStringOrNull === null) {
        dispatch({ type: SET_SELECTED_VARIANT, payload: null });
      } else {
        dispatch({ type: SET_SELECTED_VARIANT, payload: Number(newVariantAgilityIdStringOrNull) });
      }
    };

    return () => {
      // clean up :)
      window.onpopstate = null;
    };
  }, [variantAgilityId]);
};
